import Svg from "./Svg";

import avatar from "../images/image-avatar.png";

import imgCartSvg from "../images/icon-cart.svg";
import delSvg from "../images/icon-delete.svg";

import productPic from "../images/image-product-1-thumbnail.jpg";

import { useState } from "react";

function Navbar(props) {
    const [isToggle, setToggle] = useState(false);

    const [isCart, setCart] = useState(false);

    function handleNavbar() {
        setToggle(true);
        document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
        setCart(false);
    }
    function setNavbar() {
        setToggle(false);
        document.body.style.backgroundColor = "white";
    }

    function handleCart() {
        setCart(!isCart);
        setToggle(false);
        document.body.style.backgroundColor = "white";
    }

    return (
        <div className="navbar">
            <button onClick={handleNavbar} className="dropbtn">
                <Svg name="menu" />
            </button>
            <div className="dropdown">
                <div
                    className={`dropdown-content ${
                        isToggle ? "show-drop" : ""
                    }`}
                >
                    <a onClick={setNavbar} type="button" className="close">
                        <Svg name="close" />
                    </a>
                    <a href="#">Collections</a>
                    <a href="#">Men</a>
                    <a href="#">Women</a>
                    <a href="#">About</a>
                    <a href="#">Contact</a>
                </div>
            </div>
            <p className="nav-item">sneakers</p>
            <img
                className="cartSvg"
                onClick={handleCart}
                src={imgCartSvg}
                alt="cart-svg"
            />
            <div
                style={{ display: props.quantity === 0 && "none" }}
                className="count"
            >
                {props.quantity}
            </div>
            <div className={`cart-drop ${isCart ? "show-cart" : ""}`}>
                <p>Cart</p>
                <hr></hr>
                <div className="cart-items">
                    {props.quantity > 0 ? (
                        <>
                            <div className="cart-img">
                                <img src={productPic} alt="product" />
                            </div>
                            <p>Fall Limited Edition Sneakers</p>
                            <p className="sec-p">
                                $125.00 x {props.quantity}{" "}
                                <strong>${props.quantity * 125}</strong>
                            </p>
                            <img
                                onClick={() => {
                                    props.handleQuantity(0);
                                }}
                                className="del-from-cart"
                                src={delSvg}
                                alt="delete"
                            />
                        </>
                    ) : (
                        <p className="empty-cart">Your cart is empty.</p>
                    )}
                </div>
                <button style={{ display: props.quantity === 0 && "none" }}>
                    Checkout
                </button>
            </div>
            <img className="nav-item" src={avatar} alt="avatar" />
        </div>
    );
}

export default Navbar;
